import type { ExternalInvoiceFromBilly } from '@features/invoices/types/externalInvoiceFromBilly'
import { InvoiceSentState } from '@features/invoicesLegacy/enums/invoiceSentState'
import { InvoiceState } from '@features/invoicesLegacy/enums/invoiceState'
import { Invoice } from '@features/invoicesLegacy/types/invoice'
import { InvoiceType } from '@features/invoicesLegacy/types/invoiceType'

const getTaxAmountFromInvoiceLines = (invoiceLines?: string): number => {
  try {
    const parsed = JSON.parse(invoiceLines || '[]')
    if (!Array.isArray(parsed)) {
      return 0
    }

    return parsed.reduce((acc: number, line: { taxAmount?: number }) => acc + (line?.taxAmount || 0), 0)
  } catch {
    return 0
  }
}

/** As the big modal expects Invoice type, we need to map the billy external-invoice to invoice type,
 * Invoice and External Invoice are from different backend database tables and are not in a same type for now  */
export const mapBillyExternalInvoiceToInvoice = (billyApiExternalInvoice: ExternalInvoiceFromBilly): Invoice => {
  return {
    ...billyApiExternalInvoice,
    amount: billyApiExternalInvoice?.amount || 0,
    type: billyApiExternalInvoice?.type === 'creditNote' ? InvoiceType.CreditNote : InvoiceType.Invoice,
    grossAmount: billyApiExternalInvoice?.amount || 0,
    invoiceNo: billyApiExternalInvoice?.number || 'from-billy',
    sentState: InvoiceSentState.Opened,
    state: InvoiceState.Approved,
    contactName: billyApiExternalInvoice?.contact?.name,
    isPaid: billyApiExternalInvoice?.balance === 0,
    approvedTime: billyApiExternalInvoice?.entryDate,
    delivery: null,
    lineDescription: billyApiExternalInvoice.description || '',
    orderNo: billyApiExternalInvoice?.number,
    tax: getTaxAmountFromInvoiceLines(billyApiExternalInvoice?.invoiceLines),
    balance: billyApiExternalInvoice?.balance || 0,
  }
}
